export const SITE = {
    name: "Dagaz Development",
    tagline: "Build what endures.",
    email: "damonson@dagazdesigns.com",
    domain: "https://dagazdesigns.com",
    entity: "Dagaz Development is an Oregon-based design-and-build development company. It audits, designs and manages custom homes, reconstructions, commercial buildings and developer projects, and delivers them with licensed local builders, architects and suppliers across the United States and Canada.",
    oneLiner: "European design, built by licensed local partners. Custom homes, reconstructions and commercial projects from our Oregon office across the US and Canada.",
};

export const IMAGES = {
    pavilions: "https://customer-assets-agu9un31.emergentagent.net/job_caaa64a2-0e67-4e46-9a43-05fcc8d28a9a/artifacts/1f8d4768f3d7a7ad_IMG_0036.jpeg",
    aframe: "https://customer-assets-agu9un31.emergentagent.net/job_caaa64a2-0e67-4e46-9a43-05fcc8d28a9a/artifacts/cc9c01921696f34e_IMG_0038.jpeg",
    loft: "https://customer-assets-agu9un31.emergentagent.net/job_caaa64a2-0e67-4e46-9a43-05fcc8d28a9a/artifacts/ede9bdbc66add604_IMG_0052.jpeg",
    concrete: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwY29uc3RydWN0aW9uJTIwc2l0ZSUyMG1vZGVybnxlbnwwfHx8fDE3ODMwMjAzOTZ8MA&ixlib=rb-4.1.0&q=85",
    whiteConcrete: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwY29uc3RydWN0aW9uJTIwc2l0ZSUyMG1vZGVybnxlbnwwfHx8fDE3ODMwMjAzOTZ8MA&ixlib=rb-4.1.0&q=85",
    cabinChair: "https://images.unsplash.com/photo-1487695652027-48e475bfa86f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjYWJpbiUyMGludGVyaW9yJTIwd29vZCUyMGdsYXNzfGVufDB8fHx8MTc4MzEwOTEyMXww&ixlib=rb-4.1.0&q=85",
    loftInterior: "https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBsb2Z0JTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkzMjgyMjA2fDA&ixlib=rb-4.1.0&q=85",
    loftFloors: "https://images.unsplash.com/photo-1625707695772-5dd6c1f9c107?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBsb2Z0JTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkzMjgyMjA2fDA&ixlib=rb-4.1.0&q=85",
    architect: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3QlMjB3b3JraW5nJTIwYmx1ZXByaW50JTIwYmx1ZXByaW50c3xlbnwwfHx8MTc5MzI4MjIwNnx8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        slug: "custom-homes",
        name: "Custom Homes",
        short: "Ground-up homes designed around your land, light and life.",
        image: IMAGES.aframe,
        answer: "Dagaz Development designs and delivers custom homes across the United States and Canada. We audit your site, set a real budget, design the house with our European-trained team, and manage licensed local builders through to handover. You get one accountable partner from first sketch to keys.",
        deliverables: [
            "Site and feasibility audit with written findings",
            "Concept and full architectural design",
            "Engineering coordination with licensed local partners",
            "Permit applications and approvals management",
            "Fixed-scope build management with local builders",
            "Interior, exterior and landscape detailing",
            "Documented handover with care manuals",
        ],
        budget: "Every budget starts with a paid site and scope audit. Before any commitment to build, you receive a written estimate broken into design, permits, structure, envelope and finishes — with allowances named, not hidden.",
        timeline: "Most custom homes run 12 to 20 months from first consultation to handover, depending on permits, terrain and scope. You receive a dated schedule at the end of design, and it is updated weekly during the build.",
        faqs: [
            { q: "How much does a custom home cost with Dagaz?", a: "Costs depend on site, size and specification. We do not quote square-foot averages because they mislead. Instead, the audit produces a real number for your land and your brief before you commit to design." },
            { q: "Do you build in my state or province?", a: "Yes. We deliver in all 50 US states and every Canadian province and territory, working with licensed local builders in each jurisdiction while we manage design, budget and quality." },
            { q: "Can I bring my own plans?", a: "Yes. We can take existing plans through an audit, correct what needs correcting, and manage the build — or start from a blank page with you." },
        ],
    },
    {
        slug: "architecture-design",
        name: "Architecture & Design",
        short: "European design discipline, documented for local approval.",
        image: IMAGES.whiteConcrete,
        answer: "Dagaz Development provides architecture and design services for homes and commercial buildings across the US and Canada. Our European-trained designers produce concept, developed and permit-ready design, coordinated with licensed local architects and engineers of record where each jurisdiction requires them.",
        deliverables: [
            "Site analysis and massing studies",
            "Concept design with material direction",
            "Developed design with structure and envelope",
            "Permit-ready drawing sets",
            "Coordination with licensed architects and engineers of record",
            "Interior architecture and detailing",
        ],
        budget: "Design fees are fixed per phase and agreed in writing before work begins. You always know what the next phase costs before you approve it.",
        timeline: "Concept design typically takes 6 to 10 weeks. A full permit-ready set runs 4 to 8 months depending on jurisdiction and complexity.",
        faqs: [
            { q: "Who stamps the drawings?", a: "Where a jurisdiction requires a local seal, we coordinate licensed architects and engineers of record in your state or province. Design authorship stays with Dagaz; legal stamping stays with local licence holders." },
            { q: "Can I hire Dagaz for design only?", a: "Yes. Many clients complete design with us and then decide whether to continue into a managed build. The permit set is yours either way." },
        ],
    },
    {
        slug: "renovations",
        name: "Renovations & Additions",
        short: "Considered upgrades that respect what a house already is.",
        image: IMAGES.loftFloors,
        answer: "Dagaz Development plans and manages renovations and additions across the US and Canada. We begin with a building audit, decide together what stays and what changes, then design and deliver the work with licensed local builders — kitchens, whole-floor rework, extensions and full additions.",
        deliverables: [
            "Pre-renovation building audit",
            "Keep-change-remove plan with costs",
            "Design for renovations, extensions and additions",
            "Permits and structural coordination",
            "Managed construction with local builders",
            "Finish and detail supervision",
        ],
        budget: "Renovation budgets are set after the audit, once we know what is behind the walls. Contingency is stated openly in the estimate, not buried in margin.",
        timeline: "A single-room renovation typically runs 3 to 5 months including design. Whole-home renovations and additions run 8 to 14 months.",
        faqs: [
            { q: "Renovate or rebuild — how do we decide?", a: "The audit answers this. We compare the cost and disruption of renovation against reconstruction on your specific building, in writing, and recommend the option with the better long-term value." },
            { q: "Can we live in the house during work?", a: "Often yes, if the scope allows safe phasing. The audit and schedule state clearly when a house must be empty and when it can stay occupied." },
        ],
    },
    {
        slug: "reconstructions",
        name: "Reconstructions & Rebuilds",
        short: "After fire, flood or decades of wear — rebuilt properly.",
        image: IMAGES.loft,
        answer: "Dagaz Development manages reconstructions and rebuilds across the US and Canada, including homes damaged by wildfire, flood or structural failure. We document what remains, handle insurers' documentation requirements, redesign where it adds value, and rebuild with licensed local builders.",
        deliverables: [
            "Damage and structure assessment",
            "Documentation for insurance processes",
            "Rebuild vs repair analysis in writing",
            "Redesign and code-upgrade planning",
            "Managed reconstruction with local builders",
            "Defensible-space and resilience upgrades where relevant",
        ],
        budget: "Reconstruction budgets follow the assessment and your insurer's position. We provide line-item documentation designed to be read by adjusters, not just owners.",
        timeline: "Wildfire and damage rebuilds typically run 10 to 18 months from assessment to handover, driven largely by permitting and insurance timelines.",
        faqs: [
            { q: "Do you work with insurance companies?", a: "We prepare the documentation insurers require and coordinate with your adjuster. The policy and settlement remain yours; we make the building side of the claim clear and evidenced." },
            { q: "Can a rebuild improve on the original house?", a: "Yes, and it usually should. Current codes, better envelopes and lessons from the damage are built into every reconstruction design." },
        ],
    },
    {
        slug: "commercial",
        name: "Commercial Buildings",
        short: "Workplaces, hospitality and retail with lasting character.",
        image: IMAGES.concrete,
        answer: "Dagaz Development designs and manages commercial buildings across the US and Canada — workplaces, hospitality, retail and mixed-use. We deliver concept to completion with licensed local builders and engineers, with the same material discipline we bring to homes.",
        deliverables: [
            "Feasibility and site audit",
            "Concept and developed design",
            "Coordination with licensed engineers of record",
            "Permitting and approvals management",
            "Build management and quality control",
            "Fit-out, furniture and finish direction",
        ],
        budget: "Commercial budgets are built bottom-up from the audit and concept, with a clear split between shell, services and fit-out so decisions stay informed.",
        timeline: "Timelines depend on permitting and size; a small hospitality or workplace project typically runs 12 to 24 months from feasibility to opening.",
        faqs: [
            { q: "What size of commercial project do you take?", a: "We focus on boutique-scale commercial — workplaces, hospitality venues and retail up to mid-rise — where design quality materially affects the business inside." },
            { q: "Do you work with our in-house team?", a: "Yes. We regularly act as design lead and owner's representative alongside internal facilities or development teams." },
        ],
    },
    {
        slug: "developer-projects",
        name: "Developer Projects",
        short: "From feasibility to sold homes, with one partner.",
        image: IMAGES.pavilions,
        answer: "Dagaz Development organizes and finances developer projects across the US and Canada — land feasibility, entitlement, design and delivery, with structured project financing for qualifying developments up to $10 million USD. We work with landowners, investors and real estate partners from first study to sold homes.",
        deliverables: [
            "Land feasibility and yield studies",
            "Concept masterplanning",
            "Entitlement and permit strategy",
            "Design of units and shared spaces",
            "Structured project financing up to $10M USD",
            "Delivery management with local partners",
            "Real estate cooperation for land and sales",
            "Sales-ready documentation and material boards",
        ],
        budget: "Feasibility includes a full development budget — land, soft costs, construction and contingency — so the decision to proceed is made on real numbers. For qualifying projects we organize financing structures with partner lenders, up to $10 million USD.",
        timeline: "A small multi-unit project typically runs 18 to 36 months from land to completed units, depending on entitlement complexity.",
        faqs: [
            { q: "Can you organize the financing as well?", a: "Yes. For qualifying developments we arrange structured project financing with partner lenders, up to $10 million USD, underwritten on the feasibility and budget we document." },
            { q: "How do you work with real estate agents?", a: "Directly. Agents and brokers cooperate with us on land acquisition at the start and on marketing and selling completed homes at the finish. See the Partners page for how cooperation works." },
            { q: "Do you take equity positions?", a: "Sometimes. We work fee-for-service, as a co-development partner, or in hybrid structures, depending on the project and the partner." },
            { q: "What project sizes fit?", a: "Our model suits 2 to 40 unit projects where design-led product commands a premium — cabin clusters, townhomes, boutique lodges." },
        ],
    },
    {
        slug: "audits",
        name: "Building & Property Audits",
        short: "Know exactly what you are buying, keeping or building on.",
        image: IMAGES.architect,
        answer: "Dagaz Development performs paid building and property audits across the US and Canada. Before you buy land, purchase a building or commit to a renovation, we inspect, research and deliver a written report: condition, risks, permit history, realistic costs and a clear recommendation.",
        deliverables: [
            "On-site inspection with photo documentation",
            "Structure, envelope and systems review",
            "Permit and zoning history research",
            "Written report with risk register",
            "Cost ranges for repair, renovation or rebuild",
            "A clear written recommendation",
        ],
        budget: "Audits are a fixed, quoted fee agreed before the visit. The report is yours and can be used with any builder, lender or insurer.",
        timeline: "Most audits are delivered within 10 to 15 business days of the site visit.",
        faqs: [
            { q: "Why pay for an audit instead of a free estimate?", a: "Free estimates exist to win work. An audit exists to tell you the truth, including when the honest answer is do not buy or do not build." },
            { q: "Is the audit only for Dagaz clients?", a: "No. Roughly a third of audits are stand-alone — for buyers, lenders and owners who simply need an independent, documented read on a property." },
        ],
    },
    {
        slug: "project-management",
        name: "Project Management",
        short: "An owner's representative who has actually built.",
        image: IMAGES.loftInterior,
        answer: "Dagaz Development provides project management and owner's-representative services across the US and Canada. We run budget, schedule, procurement and quality on your behalf, coordinating licensed local builders and designers — and reporting to you in plain numbers, weekly.",
        deliverables: [
            "Budget and schedule ownership",
            "Builder and supplier procurement",
            "Contract administration",
            "Weekly written reporting",
            "Quality inspections at defined milestones",
            "Handover and closeout documentation",
        ],
        budget: "Management fees are a fixed percentage or monthly fee agreed up front. Our incentive is aligned with yours: finished on budget, built properly.",
        timeline: "Engagements run the length of the project, from pre-construction through closeout, with defined milestones and exit points.",
        faqs: [
            { q: "Can you manage a builder we already chose?", a: "Yes. We can administer your existing contract, run quality control and reporting, and step in on budget and schedule — without replacing your builder." },
            { q: "How do we follow progress remotely?", a: "Weekly written reports with photos, budget position and schedule status. Most of our clients manage their projects from another state or province." },
        ],
    },
    {
        slug: "interior-exterior",
        name: "Interior & Exterior Design",
        short: "Material, light and detail — inside and out.",
        image: IMAGES.cabinChair,
        answer: "Dagaz Development designs interiors and exteriors across the US and Canada as part of a build or as a stand-alone service. Stone, timber, glass, light and landscape are composed together, documented to the level a builder can price and a craftsperson can execute.",
        deliverables: [
            "Interior architecture and spatial planning",
            "Material and finish palettes with samples",
            "Lighting and joinery design",
            "Furniture direction and procurement lists",
            "Facade, deck and landscape detailing",
            "Site supervision of finishes",
        ],
        budget: "Design fees are fixed per space or phase. Procurement lists are priced openly — you see trade pricing and our margin separately.",
        timeline: "A full-home interior design typically runs 3 to 6 months, aligned with the build schedule so decisions land before trades need them.",
        faqs: [
            { q: "Can you design interiors for a house you did not build?", a: "Yes. Stand-alone interior and exterior design is a large part of our work, from single rooms to whole properties." },
            { q: "Do you supply materials?", a: "We can source timber, stone, glass and woodwork through our supplier network, delivered to your builder — with documentation and samples approved by you first." },
        ],
    },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

export const PROJECTS = [
    {
        slug: "twin-pavilions",
        name: "Twin Pavilions",
        type: "Custom Home",
        location: "Orava Forest, Slovakia",
        status: "Delivered",
        year: "2024",
        materials: "Timber / Glass / Steel",
        image: IMAGES.pavilions,
        description: "Two cedar-clad pavilions set between existing pines, joined by a glass link. The house touches the forest floor lightly — raised decks, boardwalk arrival, no tree removed.",
        detail: "The pavilions split day and night life into separate volumes, so each room borrows the forest as its fourth wall. Deep overhangs, dark steel and vertical cedar are silvering into the tree line year by year.",
    },
    {
        slug: "ridgeline-house",
        name: "Ridgeline House",
        type: "Custom Home",
        location: "High Tatras, Slovakia",
        status: "Delivered",
        year: "2023",
        materials: "Timber / Glass / Stone",
        image: IMAGES.aframe,
        description: "A long gabled form on a sloped, forested site — living spaces above, quiet rooms below, and a full-height glazed gable that frames the ridgeline like a held breath.",
        detail: "The section works with the slope instead of against it: arrival at the upper level, bedrooms stepping down into the hill. A dark stone plinth grounds the timber volume in the landscape.",
    },
    {
        slug: "warehouse-loft",
        name: "Warehouse Loft",
        type: "Reconstruction",
        location: "Berlin, Germany",
        status: "Delivered",
        year: "2024",
        materials: "Brick / Steel / Velvet",
        image: IMAGES.loft,
        description: "A reconstruction of an early-century warehouse floor — keeping the brick, the patina and the industrial window wall, and layering in warmth through texture rather than partition.",
        detail: "The rule was to add as little as possible: services dropped from the existing structure, furniture doing the work of walls, and light treated as the primary material.",
    },
    {
        slug: "canyon-offices",
        name: "Canyon Offices",
        type: "Commercial",
        location: "Vienna, Austria",
        status: "Concept study",
        year: "2026",
        materials: "Concrete / Glass",
        image: IMAGES.whiteConcrete,
        description: "A concept for a small workplace building — board-marked concrete, deep reveals and a courtyard cut that pulls daylight two storeys down into the plan.",
        detail: "The facade rhythm follows the structural grid honestly; shading is done by depth, not applied fins. A study in how few moves a calm building needs.",
    },
    {
        slug: "stillwater-cabin",
        name: "Stillwater Cabin",
        type: "Interior & Exterior",
        location: "Norrland, Sweden",
        status: "Concept study",
        year: "2025",
        materials: "Timber / Wool / Stone",
        image: IMAGES.cabinChair,
        description: "An interior concept for a lakeside cabin — one room deep, every surface timber or stone, and a single long window seat aimed at the water.",
        detail: "The palette is deliberately narrow: oiled fir, undyed wool, blackened steel. The concept explores comfort through weight and texture rather than through things.",
    },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);

export const PROCESS = [
    { n: "01", title: "Consultation & Audit", body: "We listen first, then look. A paid audit of your site or building produces written findings, real cost ranges and a clear recommendation — before you commit to anything.", duration: "2–3 weeks" },
    { n: "02", title: "Concept & Budget", body: "Design begins with massing, light and material. Alongside the concept you receive a full written budget, line by line, so the design you approve is the one you can afford.", duration: "6–10 weeks" },
    { n: "03", title: "Design & Permits", body: "Developed design, engineering coordination and permit applications, handled with licensed local partners in your state or province. You approve every milestone.", duration: "4–8 months" },
    { n: "04", title: "Build", body: "Licensed local builders construct; we manage budget, schedule and quality with weekly written reports and milestone inspections. No silence, no surprises.", duration: "8–14 months" },
    { n: "05", title: "Handover & Aftercare", body: "Documented handover — warranties, care manuals, as-built drawings — then a scheduled one-year review to keep the building performing as designed.", duration: "Ongoing" },
];

export const HOME_FAQS = [
    { q: "Where does Dagaz Development build?", a: "Everywhere in the United States and Canada. Our office is in Oregon; delivery happens with licensed local builders, architects and suppliers in your state or province, managed by us." },
    { q: "Is Dagaz a contractor?", a: "We are a design-and-build development company. Design, budget and quality are managed by Dagaz; physical construction is performed by licensed builders in your jurisdiction — the structure that keeps every project legal, insured and accountable." },
    { q: "How much will my project cost?", a: "An honest answer needs your site and your brief. That is why every project starts with a paid audit that produces real numbers — written down, line by line — before you commit to design or construction." },
    { q: "How long does a custom home take?", a: "Most custom homes run 12 to 20 months from first consultation to handover. Permits, terrain and scope decide where inside that range you land; the audit tells you early." },
];

export const FAQ_GROUPS = [
    {
        group: "Working with Dagaz",
        items: [
            { q: "How do we start?", a: "With a conversation, then an audit. Write to damonson@dagazdesigns.com or use the project brief form. You will hear back within two business days." },
            { q: "Who actually builds my project?", a: "Licensed builders in your state or province, contracted for your project. Dagaz designs, manages budget and schedule, and inspects quality at every milestone — one accountable partner for you." },
            { q: "Do I need to own land already?", a: "No. Many clients start with a land audit before they buy. It is far cheaper to walk away from the wrong parcel than to fix it later." },
            { q: "Can I hire Dagaz for design only?", a: "Yes. Design-only engagements are common. The permit-ready set is yours, and you can continue into a managed build later or not at all." },
        ],
    },
    {
        group: "Budget & Financing",
        items: [
            { q: "How are budgets set?", a: "Bottom-up, after the audit — design, permits, structure, envelope and finishes, line by line in writing. We do not quote square-foot averages because they mislead." },
            { q: "Can you help with construction financing?", a: "Yes. We prepare the documentation lenders ask for and can introduce construction-loan partners. Financing decisions always stay with you and your lender." },
            { q: "What deposit is required?", a: "Design phases are billed fixed-fee in stages. Construction deposits follow the builder's contract in your jurisdiction, which we review with you before signing." },
        ],
    },
    {
        group: "Coverage",
        items: [
            { q: "Which states and provinces do you cover?", a: "All 50 US states and all Canadian provinces and territories. The delivery model — Dagaz management plus licensed local builders — was designed exactly for this." },
            { q: "Do you take remote or rural sites?", a: "Yes, and we enjoy them. Forest, coast and mountain sites are where the design language comes from. The audit assesses access, services and cost impact honestly." },
        ],
    },
    {
        group: "The Company",
        items: [
            { q: "Who is Miro Damonson?", a: "The founder. Trained in art and design in Europe, he led development work with DMELL in Slovakia before moving to Oregon and founding Dagaz Development — to build fewer, better things." },
            { q: "Why the name Dagaz?", a: "Dagaz is the rune of dawn and new beginnings. Every project — a first home, a rebuild after a fire, a new venture — is exactly that." },
        ],
    },
];

export const NAV_LINKS = [
    { to: "/services", label: "Services" },
    { to: "/projects", label: "Projects" },
    { to: "/how-it-works", label: "Process" },
    { to: "/financing", label: "Financing" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export const FINANCING = {
    types: [
        { name: "Construction Loan", body: "Short-term financing that funds the build in draws, inspected and released at each milestone. Converted or refinanced when the building is complete." },
        { name: "Construction-to-Permanent", body: "One closing, one loan. It funds the construction phase, then converts automatically into your long-term mortgage — no second approval, no second fees." },
        { name: "Land as Down Payment", body: "Own your lot already? Its equity can serve as your down payment, reducing the cash you bring to closing. We document the value clearly for the appraisal." },
        { name: "Developer Facilities", body: "For qualifying multi-unit and commercial developments, organized project financing up to $10 million USD — underwritten on the feasibility, budget and schedule we prepare." },
    ],
    steps: [
        { title: "Audit & Budget", body: "The paid audit produces real numbers — a line-by-line budget lenders can actually underwrite, not a guess per square foot." },
        { title: "Lender Introduction", body: "We introduce partner lenders who finance construction in your state or province, and who already understand our documentation." },
        { title: "Appraisal & Approval", body: "Plans, budget, schedule and builder contracts go to the lender as one package. Approval moves faster when nothing is missing." },
        { title: "Closing & Draws", body: "Once closed, we manage draw requests against inspected milestones, so the build is never waiting on paperwork." },
    ],
    lenderPackage: [
        "Line-by-line budget from the audit",
        "Permit-ready plans and engineering status",
        "Builder contracts with licensed local partners",
        "Dated construction schedule with milestones",
        "Draw management and inspection reports",
    ],
    faqs: [
        { q: "How much can be financed?", a: "Qualifying developer and commercial projects can be financed up to $10 million USD through our partner lenders. Home construction loans depend on the borrower, the appraisal and the project — the audit establishes the real number early." },
        { q: "Is Dagaz a lender?", a: "No. Financing is provided by partner lenders, and all lending decisions rest with them. Our job is to make your project easy to say yes to: documented budget, real plans, credible schedule." },
        { q: "Can land count as my down payment?", a: "Often, yes. If you own your lot, its equity can serve as the down payment with many construction lenders. We prepare the documentation the appraisal needs." },
        { q: "Does this work in Canada too?", a: "Yes. Structures differ by province and state, but construction financing exists in every market we serve, and our partner network covers both countries." },
    ],
};

export const PARTNERS = {
    tracks: [
        {
            name: "For Builders",
            tag: "Licensed general builders & trades",
            body: "Dagaz brings licensed builders ready clients with designed projects. We handle the first stage of client communication and the design. You build and contract directly with the homeowner. Partnerships are individual, set on a call, with one partner per trade in each area.",
            points: ["Ready clients with designed, budgeted projects", "Direct contract with the homeowner", "One partner per trade in each area"],
        },
        {
            name: "For Architects & Engineers",
            tag: "Local licence holders",
            body: "Our European-trained design team authors the concept; licensed architects and engineers of record carry the local seal where the jurisdiction requires it. A steady flow of design-led projects, documented to the level your stamp deserves.",
            points: ["Design-led projects with real budgets", "Clear scope: seal, calculations, coordination", "Paid on milestone, never on promises"],
        },
        {
            name: "For Suppliers",
            tag: "Timber, woodwork, stone, glass",
            body: "Our buildings are specified in timber, stone and glass — properly documented, sampled and scheduled. Suppliers receive clear specifications, realistic lead times and direct purchase contracts.",
            points: ["Documented specifications and samples", "Scheduled orders with real lead times", "Direct contracts, prompt terms"],
        },
        {
            name: "For Lenders & Agents",
            tag: "Financing & real estate cooperation",
            body: "Our partner lenders explain financing options to clients whose projects are already documented and budgeted. Real estate agents and brokers cooperate on land acquisition and on selling completed developer projects.",
            points: ["Pre-documented borrowers and projects", "Land and listing cooperation on developments", "Facilities up to $10M USD on qualifying projects"],
        },
    ],
    process: [
        { title: "Introductory Call", body: "Thirty minutes: your trade, your territory, your best work. If the fit is real, we define a pilot together." },
        { title: "Pilot Project", body: "One real project, one clear scope. We learn how each other works before anything is exclusive." },
        { title: "Area Partnership", body: "After a successful pilot, the area is yours — one partner per trade, with a steady, documented flow of work." },
    ],
};

export const BUDGET_RANGES = ["Under $500k", "$500k – $1M", "$1M – $2.5M", "$2.5M – $5M", "Over $5M", "Not sure yet"];
export const TIMELINES = ["As soon as possible", "Within 6 months", "6–12 months", "1–2 years", "Just exploring"];
export const FINANCING_OPTIONS = ["Self-funded", "Construction loan needed", "Exploring financing options", "Prefer to discuss"];
